var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxBookAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.3335V12.6668C2 14.1342 3.196 14.6668 4 14.6668H14V13.3335H4.008C3.7 13.3255 3.33333 13.2042 3.33333 12.6668C3.33333 12.5995 3.33933 12.5395 3.34933 12.4848C3.424 12.1008 3.73867 12.0068 4.008 12.0002H14V2.66683C14 1.9315 13.402 1.3335 12.6667 1.3335H4C3.196 1.3335 2 1.86616 2 3.3335V5.3335ZM4 2.66683H12.6667V10.6668H3.33333V3.3335C3.33333 2.79616 3.7 2.67483 4 2.66683Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.33333H8.66634V7.33333H10.6663V6H8.66634V4H7.33301V6H5.33301V7.33333H7.33301V9.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBookAdd);
export default __webpack_public_path__ + "static/media/bx-book-add.579e40f6e1f70326675695a2af998c89.svg";
export { ForwardRef as ReactComponent };